import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../core/withGShoc';
import IsolatedResourceSlat from './IsolatedResourceSlat';

const loadOptions = {
    predicates: [
        "https://grafsync.graphifi.com/schema/gs/inDataset",
        "http://www.w3.org/2000/01/rdf-schema#label",
        "http://www.w3.org/2002/07/owl#deprecated",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
    ]
};

class IsolatedResource extends React.Component {

    render() {

        const { position, data, lang, onSelect, viewLang, iriOptions, datasetIRI, addToDataset, useWorkflow, activeResource } = this.props;

        // If somebody else has deleted it we will now hide it
        if (data.pendingDeletion) return null;

        return (
            <div>
                <IsolatedResourceSlat
                    defaultLang={lang}
                    datasetIRI={datasetIRI}
                    useWorkflow={useWorkflow}
                    position={position}
                    iriOptions={iriOptions}
                    addToDataset={addToDataset}
                    activeResource={activeResource}
                    viewLang={viewLang}
                    data={data}
                    onSelect={onSelect} />
            </div>
        );
    }
}

IsolatedResource.propTypes = {
    useWorkflow: PropTypes.bool,
    isReadOnly: PropTypes.bool.isRequired,
    datasetIRI: PropTypes.string,
    addToDataset: PropTypes.func,
    data: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    activeResource: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    iriOptions: PropTypes.object
};

export default withGS(IsolatedResource, ["ALL"], null, loadOptions, true);